// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"lwb9i":[function(require,module,exports) {
require("734b3ee20f478faf").register(require("32ef3e6d9dcc0203").getBundleURL("5mfoe"), JSON.parse('["5mfoe","index.d157c8be.js","7ACci","AdminRouter.dd9c7f84.js","lXpzF","Login.d3e21212.js","bfXgo","css/CustomComponent.css","4SPlU","Register.a415c786.js","5yoYu","DashboardPage.bcd3d466.js","bLqWm","DashboardPage.1ca45282.css","jcTth","AdminRouter.51efdbf2.js","mhBla","ProductPage.d8735a3c.js","epLMS","ProductPage.6e4b98ac.js","kpnGP","SettingsPage.0a2c6e13.js","f9ur7","VideoPlayer.6f72d708.js","1GAbm","YouTube.34986941.js","Y2iBt","SoundCloud.d14314e7.js","eKE28","Vimeo.6de1965b.js","fiBpe","Facebook.495e6944.js","4d9VP","Streamable.2b930263.js","6Fmtr","Wistia.6e5c0fa0.js","6fq9N","Twitch.4887e793.js","1vRkD","DailyMotion.42d6fc75.js","3Ie9I","Mixcloud.01d62d27.js","ecf50","Vidyard.2b249b05.js","hNx0a","Kaltura.2bb1d4eb.js","3zxa2","FilePlayer.2db067be.js","fDy7j","Preview.2bb065bc.js","6wgV1","CustomizeVideo.aa2a0e3d.js","cfYim","css/video.css","kxnNq","CustomizeVideo.b2b83054.js","gleBb","ShoppableVideoPreview.152fa24b.js","btZZt","ShoppableVideoPreview.4184de45.js","5ctxL","ShoppableVideoPreview.9ea73788.js","fnlND","ShoppableVideoList.d26c1584.js","2fW3M","ShoppableVideoList.9f5f124e.js","iTGex","AdminRouter.07e08c31.js","eeud3","Room.47f3d997.js","9LFU7","Room.21cb407b.css","bRd8a","LiveShoppingList.526622fe.js","lEPiZ","ShoppableVideoForm.c246fbb6.js","cgTc9","Configuration.0140f712.js","c9sJL","GeneralConfiguration.65bb2762.js","32dPH","StoreConfiguration.bd995eb1.js","bMUtH","Staff.50257cf5.js","2zgRa","Staff.4a9d92ed.js","6s42t","Plan.5651de28.js","eaHnP","EmailConfiguration.22b00339.js","lU1BX","Addons.08263a7d.js","dgwIs","ViewRoom.fba6c2be.js","8vrVa","VideoCollection.8da9e6cb.js","hZCrM","AddVideoCollection.9c75a604.js","cMwBP","FeaturedApps.40e0c7d4.js","loI1H","InstagramConnectorPage.f336003c.js","ezlyP","AdminRouter.db3326aa.css","f0A8N","AdminRouter.6a980554.js","ckDVe","images/live_comm_customer_page20.png","7bvtT","images/shoppable_videos.png","cMgfz","images/seamless_shopify_integration.png","3gcXW","images/live_shopping_featurecard.png","2Lt8p","images/live_shopping_feature_left.png","6czqO","images/live_shopping_feature_right.png","1dLtm","images/LiveShopping_phone.png","1V6zR","images/live_shopping_feature_bl.png","bvUUm","images/live_shopping_feature_br.png","ddKI5","images/shopify_img.png","2xbqG","images/woo_img.png","fzfwS","images/adobe_img.png","czwKj","images/shopware_img.png","7uobP","images/hero_section_products.png","j1t9j","hero_video.3a021005.mp4","9MFJk","verticle_left.664f7ede.mp4","9sSSJ","verticle_right.8b885578.mp4","2ES0X","images/hide_password_Icon.png","hkK8G","images/password_Icon.png","exRa7","images/login-illustration.svg","i9s9u","images/apple-touch-icon.png","abXDl","images/Vector.svg","4HqY5","images/dummy_shopify_product.webp","4SZmN","images/delete_red.png","mbAkk","images/image-thumbnail.svg","6abSo","images/product_action.png","3W8KQ","images/ClockIcon.png","dzfbD","images/ChatIcon.png","5WkFM","images/StoreIcon.png","drIcT","images/Ellipse_left.png","hgc5d","images/Ellipse_right.png","cgy9y","images/play_icon.png","kfCf6","images/pause_icon.png","lmjDA","images/skip_icon.png","duoCu","images/replay_icon.png","3QFX6","images/logo.png","lp57c","images/profile.svg","loSrf","images/reset-password-illustration.svg","1nT3H","images/external-link-16.png","8dLAT","images/lucide_info.svg","cK9PU","images/outline.svg","4eQd0","images/livecommerce-logo.png","jNeAU","images/action-icon.png","6QrVR","images/dashboard_product.svg","575z5","images/dashbaord_video.svg","lVr1Q","images/room-lg-selected.svg","kDC9s","images/screen_Desktop.png","h0Sz2","images/screen_Tab.png","kWAo8","images/screen_Desktop_Selected.png","6GY8c","images/screen_Tab_Selected.png","hC29Z","images/screen_Mobile.png","7kaNM","images/screen_Mobile_Selected.png","dYAZl","images/settings.svg","2fQOF","images/settings(1).svg","5bJxx","images/Staff-active.png","776Dk","images/Staff-normal.png","eHkHK","images/dashboard.svg","59J2s","images/dashboard(1).svg","dG3xs","images/product.svg","7Qwjo","images/product(1).svg","gZa5s","images/plans.svg","gRwtE","images/plans(1).svg","1I4P8","images/video-recorder.svg","lApJb","images/video-recorder(1).svg","8fV9d","images/room.svg","bmwm0","images/room-selected.svg","72cnt","images/left-chevron.svg","cFRGX","images/right-chevron.svg","EyO7d","images/logout.svg","abj50","images/delete-icon.png","c1QMR","images/product_add.png","8IvMZ","images/productEdit.png","imfHg","images/live-commerce.svg","koDBd","images/play.png","lTc9g","images/pause.png","jpEtR","images/speaker.png","4Q2ai","images/mute.png","7PKaq","images/full_screen.png","cxtzA","images/off_screen.png","2hEqq","images/Sora.png","jJvf7","images/landing_page_logo.png","kGCkC","images/live-commerce-admin-view.webp","gXW8F","images/live-commerce-customer-view.webp","iCUDD","images/icon-customizable-store-preview.webp","atAIh","images/icon-digital-storage.webp","5VeNR","images/icon-easy-downgrade-upgrade-plans.webp","lepUf","images/icon-live-streaming.webp","4yB1R","images/icon-product-listings.webp","bDqSN","images/icon-schedule-live-streams.webp","5cQwg","images/icon-shoppable-videos.webp","6CRnb","images/icon-staff-management-dashboard.webp","dBxhO","images/live_com_facebook.svg","eCLXZ","images/live_com_instagram.svg","53HJY","images/live_com_linkedin.svg","2Kykf","images/power_plug.png","imAuh","images/web_view_carousel.webp","8HpBK","images/desktop_web_card.webp","czlKw","images/mobile_carousel_view.webp","lfopP","images/mobile_card_view.webp","8X4p1","images/Instagram_icon.png","4ebYR","images/reelicon.png","fAq4x","AdminRouter.688e6898.js","lv6T3","AdminRouter.efd6029a.js","jca7A","AdminRouter.dbd41aaf.js","3fzs1","AdminRouter.ba86c883.js","hEVea","StaffRouter.1b46c7a9.js","b6919","SubscribeCustomer.f3bf0207.js","7VzBx","AppRouter.0b1f8fd2.js","7qRDr","BroadcastRouter.2660bb81.js","bmzkp","LandingPageRouter2.b129f468.js","M7N6X","css/index.css"]'));

},{"734b3ee20f478faf":"fyJL2","32ef3e6d9dcc0203":"c7Tr5"}],"fyJL2":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"c7Tr5":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["lwb9i"], null, "parcelRequire1ea1")

//# sourceMappingURL=index.runtime.f82230a9.js.map
